var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { isEmpty } from "lodash";
import { useCallback, useContext, useEffect, useRef, useState, } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { getLogout, } from "../../apis/dashboard";
//import { getDummyIndicesMaster } from "../../apis/mock/data/get-indices-master";
import SearchModule from "../../components/search/search-new";
import { ThemeContext } from "../../contexts/theme-context";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import Margin from "../../modals/margin/margin";
const { REACT_APP_URL_ASSET_BASE_PATH, REACT_APP_ENV, REACT_APP_URL_MODIFICATION, REACT_APP_VERSION, } = process.env;
import { debounce } from "lodash";
import { marginUpdate } from "src/redux/reducers/non-persist";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { disableDragging, disableMarquee, enableDragging, enableMarquee, enableStickyForm, } from "../../redux/reducers/app";
import { onModalOpenClose } from "../../redux/reducers/modals";
import { persistor } from "../../redux/store";
import { getEnvironmentVariableOrEmpty, getPreferences, setPreferences, } from "../../utils/methods";
import IndicesBar from "./indices";
import styles from "./navbarOne.module.scss";
//import { SEARCH_FROM, THEME_LIGHT } from "src/utils/constant";
import Webhook from "src/pages/webhook/webhook";
import { CHANNEL_BROADCAST, DEFAULT_LOGIN_URL, DEMAT_ACCOUNT_OPENING_URL, SEARCH_FROM, THEME_LIGHT, USER_LOGOUT, } from "src/utils/constant";
import { clearSessionData, getDataFromSession, SESSION_KEYS, setDataInSession, } from "src/utils/session-storage";
import { Tooltip } from "react-bootstrap";
import { notificationApi } from "src/apis/dashboard";
import MarketStatus from "src/modals/common/MarketStatus";
import DebitFunding from "src/modals/debitFunding/debitFunding";
import PrimaryButtonBeforeLogin from "../ui/buttons/beforeLogin/primary";
import SecondaryButtonBeforeLogin from "../ui/buttons/beforeLogin/secondary";
const Navbar = ({ onSearchFocus, }) => {
    const dispatch = useAppDispatch();
    const isDraggable = useAppSelector((state) => state.app.isDraggable);
    const [webhookOpen, setWebhookOpen] = useState(false);
    const [isStickyForm, setStickyForm] = useState(getPreferences().profile.isStickyOrder);
    const onChangeWebhook = () => setWebhookOpen((webhookOpen) => !webhookOpen);
    const showMarquee = useAppSelector((state) => state.app.showMarquee);
    const updateMarginValue = useAppSelector((state) => state.nonPersist.shouldMarginUpdate);
    const isWindowFocused = useAppSelector((state) => state.app.isWindowFocused);
    const interval = useRef();
    const [clientCode] = useState(() => getDataFromSession(SESSION_KEYS.CLIENT_CODE) || "");
    const [searchOpen, setSearchOpen] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [debouncedSearchString, setDebouncedSearchString] = useState("");
    const [showMarginDetail, setShowMarginDetail] = useState(false);
    //const[isDarkTheme,setDarkTheme]=useState(false);
    const { theme, toggleTheme } = useContext(ThemeContext);
    const themeChange = useContext(ThemeContext);
    const setShowMarginDetailCallback = (newValue) => {
        setShowMarginDetail(newValue);
    };
    const ref = useRef();
    const [selectedValue] = useState(() => "derivatives");
    // const [isActive] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    // const [profile, setProfile] = useState(false);
    // const [financial, setFinancial] = useState(false);
    // const [research, setResearch] = useState(false);
    // const [utilities, setUlitilies] = useState(false);
    // const [developer, setDeveloper] = useState(false);
    // const [themeDD, setThemeDD] = useState(false);
    const [selectedThemeMenu, setSelectedThemeMenu] = useState(getDataFromSession(SESSION_KEYS.THEME));
    // const [marginModalDisplay, setMarginModalDisplay] = useState(false);
    const [dropdownType, setDropdownType] = useState("");
    const onDropdownTypeChange = (type) => {
        if (dropdownType == type) {
            setDropdownType("");
        }
        else {
            setDropdownType(type);
        }
    };
    const renderTooltip = useCallback((toolname) => {
        return _jsx(Tooltip, Object.assign({ className: "" }, { children: toolname }));
    }, []);
    const [marketStatusModal, setMarketStatusModal] = useState(false);
    const [debitFundingModal, setDebitFundingModal] = useState(false);
    const toggleMarketStatusModal = useCallback(() => {
        setMarketStatusModal(!marketStatusModal);
    }, [marketStatusModal]);
    const toggleDebitFundingModal = useCallback((newValue) => {
        if (newValue !== undefined) {
            setDebitFundingModal(newValue);
        }
        else {
            setDebitFundingModal(!debitFundingModal);
        }
    }, [debitFundingModal]);
    const handleOpenDebitFundingModal = useCallback(() => {
        setShowMarginDetailCallback(false);
        toggleDebitFundingModal(true);
    }, []);
    const isPledgeUnPldge = useAppSelector((state) => {
        return state.modals.pledgeunpledgeModal;
    });
    let errorMessage;
    const [openNotifications, setNotifications] = useState(false);
    const [notificationData, setNotificationData] = useState([]);
    //SET NOTIFICATION COUNT METHOD
    // const [nCount, setNCount] = useState(0);
    const openCloseNotification = () => {
        if (!openNotifications)
            setDataInSession(SESSION_KEYS.NOTIFICATION_OPEN_TIME, Date.now(), true);
        setNotifications(!openNotifications);
        //setNCount(0);
    };
    const getNotification = () => __awaiter(void 0, void 0, void 0, function* () {
        //  setDataLoading(true);
        try {
            let notificationOpenTime = getDataFromSession(SESSION_KEYS.NOTIFICATION_OPEN_TIME);
            if (!notificationOpenTime) {
                notificationOpenTime = new Date();
                notificationOpenTime = notificationOpenTime.setHours(9, 15, 0, 0);
                setDataInSession(SESSION_KEYS.NOTIFICATION_OPEN_TIME, notificationOpenTime, true);
            }
            let LastRequestedTime = getDataFromSession(SESSION_KEYS.NOTIFICATION_LAST_TIME);
            if (!LastRequestedTime) {
                LastRequestedTime = new Date();
                LastRequestedTime = LastRequestedTime.setHours(9, 15, 0, 0);
            }
            const resp = yield notificationApi(LastRequestedTime);
            //const resp: any = { data: getDummyNotification() };
            const tempNotificationData = resp.data.body.NotificationCenter;
            setNotificationData(tempNotificationData);
            // let tempCount = 0;
            // if (tempNotificationData.length > 0) {
            //   tempNotificationData.map((data) => {
            //     const tempData = data.NotificationTime.replace("/Date(", "")
            //       .replace(")/", "")
            //       .split("+")[0];
            //     const date1 = Number(tempData);
            //     const date2 = Number(notificationOpenTime);
            //     if (date1 > date2) {
            //       tempCount = tempCount + 1;
            //     }
            //   });
            //   setNCount(tempCount);
            // } else {
            //   setNCount(tempCount);
            // }
            setDataInSession(SESSION_KEYS.NOTIFICATION_LAST_TIME, Date.now(), true);
        }
        catch (err) {
            errorMessage = err.message;
        }
        finally {
            // setDataLoading(false);
        }
    });
    // useEffect(() => {
    //   getNotification();
    //   // Create an interval to call the API every 5 minutes.
    //   const interval = setInterval(getNotification, 0.3 * 60 * 1000);
    //   // Clear the interval when the component unmounts.
    //   return () => clearInterval(interval);
    // }, []);
    const onMarqueeToggleChange = useCallback((isChecked) => {
        captureCleverTabAnalytics("Ticker event - Ticker ON/OFF - FNO", {
            TickerValue: isChecked ? "ON" : "OFF",
        });
        if (isChecked) {
            dispatch(enableMarquee());
        }
        else {
            dispatch(disableMarquee());
        }
    }, [dispatch]);
    const onChainUIChange = useCallback((isChecked) => {
        if (isChecked) {
            dispatch(enableDragging());
        }
        else {
            dispatch(disableDragging());
        }
    }, [dispatch]);
    // useEffect(() => {
    //   setSellAuthModalOpen(edisData != undefined);
    // }, [edisData]);
    // -------------------------------------------------------------- API CALLING ----------------------------------------------------------------------------------------
    // Fetching/Getting the data from the Margin API
    const [marginValue, setMarginValue] = useState(0);
    const [marginData, setMarginData] = useState();
    const [mfMargin, setMfMargin] = useState({
        BODLB: 0,
        AdHoc: 0,
        Receipts: 0,
        Payments: 0,
        MBPO: 0,
        AvlbMargin: 0,
        MFCollateralValue: 0,
        MFFreeStockValue: 0,
        MFHaircutValue: 0,
        LiqColVal: 0,
        LiqHaircut: 0,
        NonLiqColVal: 0,
        NonLiqHaircut: 0,
    });
    const [marginPlus, setMarginPlus] = useState("N");
    // Margin plus status
    const getMarginPDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        // const marginPlusData = await getMarginPlusDetails();
        // if (marginPlusData?.data?.body) {
        //   setMarginPlus(marginPlusData?.data?.body?.MTFOpted);
        // }
    });
    useEffect(() => {
        getMarginPDetails();
    }, []);
    const fetchMargin = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            // const resultFromMargin = await dashboardWorkerRef.getMarginImpl(
            //   searchUIDRef.current
            // );
            // const resultFromMargin = await getMargin();
            // const resultFromMargin = { data: getMarginDummyData() };
            // New Margin V11 API
            const resultFromMarginV11 = { data: { body: {} } };
            // const resultFromMarginV11 = { data: getMarginV11DummyData() };
            if ((_a = resultFromMarginV11 === null || resultFromMarginV11 === void 0 ? void 0 : resultFromMarginV11.data) === null || _a === void 0 ? void 0 : _a.body) {
                // setMarginData();
                // marginData.EquityMargin.AvailableAmount
                // setMarginValue(
                //   resultFromMarginV11?.data?.body?.EquityMargin[0]?.AvailableAmount
                // );
            }
            // const resultFromMFMargin = await getMFMargin();
            // if (resultFromMFMargin?.data.body.status == "0") {
            //   setMfMargin(resultFromMFMargin.data.body.mfmargindetails);
            // }
            // if (resultFromMarginV11.data.body.Status == 0) {
            //   setMarginV11(resultFromMarginV11.data.body.EquityMargin);
            // }
        }
        catch (err) {
            console.error(err);
        }
        finally {
            if (interval.current) {
                clearTimeout(interval.current);
                interval.current = undefined;
            }
            interval.current = setTimeout(() => {
                if (!marginUpdate) {
                    fetchMargin();
                }
            }, 10000);
            dispatch(marginUpdate(false));
        }
    }), []);
    useEffect(() => {
        if (updateMarginValue) {
            fetchMargin();
        }
    }, [updateMarginValue]);
    useEffect(() => {
        if (isWindowFocused) {
            fetchMargin();
        }
        else if (interval.current) {
            clearTimeout(interval.current);
            interval.current = undefined;
        }
        return () => {
            if (interval.current) {
                clearTimeout(interval.current);
                interval.current = undefined;
            }
        };
    }, [isWindowFocused]);
    const marketStatusClick = () => {
        toggleMarketStatusModal();
    };
    const handleTradeStation = () => {
        window.open("https://tradestation.5paisa.com/ssologin", "_blank");
    };
    const logout = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const logoutResult = yield getLogout();
        }
        catch (error) {
            console.error(error);
        }
        finally {
            document.cookie =
                "5paisacookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=.5paisa.com; path=/;";
            document.cookie =
                "JwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            clearSessionData(true);
            // handlePageHide();
            persistor.purge().then(() => {
                window.location.replace("https://Invest.5paisa.com/home/logout");
                const channel = new BroadcastChannel(CHANNEL_BROADCAST);
                channel.postMessage({
                    event: USER_LOGOUT,
                    // add more keys as needed
                });
                channel.close();
            });
        }
    }), []);
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const checkIfClickedOutside = (e) => {
            if (searchOpen && ref.current && !ref.current.contains(e.target)) {
                setSearchOpen(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [searchOpen]);
    const close = useCallback(() => {
        setSearchString("");
        setDebouncedSearchString("");
        dispatch(onModalOpenClose({
            componentName: "globalSearch",
            currState: "close",
        }));
    }, []);
    function handleEsc(event) {
        if (event.keyCode === 27) {
            setSearchString("");
            setDebouncedSearchString("");
        }
    }
    useEffect(() => {
        window.addEventListener("keydown", handleEsc);
        dispatch(enableStickyForm(isStickyForm));
        return () => {
            ref.current = undefined;
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);
    // const marginModal = (): void => {
    //   setMarginModalDisplay(!marginModalDisplay);
    // };
    const searchStringDebounce = debounce((event) => {
        captureCleverTabAnalytics("Search Bar event text - Search Bar - FNO", {
            SearchValue: event.target.value,
        });
        setSearchString(event.target.value);
    }, 500);
    const getSearchResults = useCallback(debounce((value) => {
        captureCleverTabAnalytics("Search Bar event text - Search Bar - FNO", {
            SearchValue: value,
        });
        setDebouncedSearchString(value);
    }, 500), []);
    useEffect(() => {
        getSearchResults(searchString);
    }, [searchString]);
    const onStickyFormChange = (isChecked) => {
        setStickyForm(isChecked);
        const myPref = getPreferences();
        myPref.profile.isStickyOrder = isChecked;
        setPreferences(myPref);
        dispatch(enableStickyForm(isChecked));
    };
    function finalReturnValues() {
        return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.headerWrapper}` }, { children: [_jsx("div", Object.assign({ className: `${styles.siteLogoWrapper}` }, { children: _jsx("a", Object.assign({ href: "/", className: `${styles.siteLogo}` }, { children: _jsx("img", { src: theme === THEME_LIGHT
                                        ? "https://images.5paisa.com/Tradestation/5PaisaLightLogo.svg"
                                        : "https://images.5paisa.com/Tradestation/5PaisaDarkLogo.svg", alt: "5Paisa Logo" }) })) })), _jsx("div", Object.assign({ className: `${styles.indicesWrapper}` }, { children: _jsx(IndicesBar, {}) })), _jsx(OutsideClickHandler, Object.assign({ onOutsideClick: () => {
                                if (!isPledgeUnPldge)
                                    setShowMarginDetailCallback(false);
                            } }, { children: _jsxs("div", Object.assign({ className: `${styles.outerDivForMargin} ms-0 posRel` }, { children: [_jsxs("div", Object.assign({ className: styles.marginOuterDiv }, { children: [_jsx("span", Object.assign({ className: styles.textForSensex }, { children: "MARGIN" })), _jsx("span", Object.assign({ className: styles.valueForMargin }, { children: "0.00" }))] })), showMarginDetail && marginData && mfMargin && (_jsx(Margin, { marginModalData: marginData, mfMargin: mfMargin, isMarginPlus: marginPlus, handleOpenDebitFundingModal: handleOpenDebitFundingModal }))] })) })), debitFundingModal && (_jsx(DebitFunding, { isOpen: debitFundingModal, toggleDebitFundingModal: toggleDebitFundingModal })), _jsx("div", Object.assign({ className: styles.textForFunds }, { children: _jsx("a", { className: "squarePlusIconBlue" }) })), _jsx("div", Object.assign({ className: `${styles.navBarCenter}` }, { children: _jsx("div", Object.assign({ className: `${styles.outerDivForSearch} flex-fill` }, { children: _jsx("div", Object.assign({ ref: ref }, { children: _jsxs("div", Object.assign({ className: `${styles.innerDivForSearch} posRel` }, { children: [_jsxs("div", Object.assign({ className: styles.innerDivForCenterAlign }, { children: [_jsx("img", { src: getEnvironmentVariableOrEmpty(REACT_APP_URL_ASSET_BASE_PATH) + "/fno/assets/svgs/search.svg", className: styles.searchIcon, alt: "Search-icon" }), _jsx("input", { onClick: () => {
                                                            if (onSearchFocus) {
                                                                onSearchFocus();
                                                            }
                                                            setSearchOpen((oldState) => oldState || true);
                                                        }, 
                                                        // value={searchString}
                                                        type: "text", onChange: (event) => {
                                                            // setSearchString(event.target.value);
                                                            searchStringDebounce(event);
                                                            event.target.value.length > 0
                                                                ? dispatch(onModalOpenClose({
                                                                    componentName: "globalSearch",
                                                                    currState: "close",
                                                                }))
                                                                : dispatch(onModalOpenClose({
                                                                    componentName: "globalSearch",
                                                                    currState: "open",
                                                                }));
                                                        }, className: styles.input, placeholder: "Search & Trade" }), !isEmpty(searchString) && (_jsx("span", { title: "Close", className: `${styles.closeIcon} pointer`, onClick: close }))] })), searchOpen && (_jsx(SearchModule, { toggleModal: () => { }, searchFrom: SEARCH_FROM.GLOBAL, queryString: debouncedSearchString, closeSearch: () => {
                                                    setSearchOpen(false);
                                                } }))] })) })) })) })), _jsxs("div", Object.assign({ className: `d-flex align-items-center gap-2 ${styles.paloginCtaWrap}` }, { children: [_jsx(SecondaryButtonBeforeLogin, { className: `py-1 ${styles.paloginCtaButton}`, label: "Login", to: `${DEFAULT_LOGIN_URL}`, target: "_blank" }), _jsx(PrimaryButtonBeforeLogin, { className: `py-1 ${styles.paloginCtaButton}`, label: "Open Demat Account", to: `${DEMAT_ACCOUNT_OPENING_URL}`, target: "_blank" })] }))] })), _jsx("div", Object.assign({ className: webhookOpen && styles.webhookPanelBackdrop }, { children: _jsx(OutsideClickHandler, Object.assign({ onOutsideClick: () => {
                            setWebhookOpen(false);
                        } }, { children: webhookOpen && (_jsx(Webhook, { closeWebHookModal: () => {
                                setWebhookOpen(false);
                            } })) })) })), marketStatusModal && (_jsx(MarketStatus, { marketStatusModal: marketStatusModal, toggleMarketStatusModal: toggleMarketStatusModal }))] }));
    }
    return _jsx(_Fragment, { children: finalReturnValues() });
};
export default Navbar;
